import { Skeleton, Typography } from "@mui/material";
import { useSubscriptionContext } from "../../context/subscription/SubscriptionContext";
import SubscriptionCard from "./SubscriptionCard";
import { Box } from "@mui/system";
import { COLORS } from "../../ui/Theme";
import { getCookie } from "../../lib/dashboard/actions";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const Subscription = () => {
    const {
        plansData,
        isPlansLoading,
        setSelectedPlan,
    } = useSubscriptionContext();

    const authToken = getCookie("authToken");
    const navigate = useNavigate();

    // select plan and checks for auth token and then redirect
    const getInfoHandler = (selectedCard) => {
        setSelectedPlan(selectedCard);
        if (!authToken) navigate("/login")
        else navigate("orders")
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "50px",
                height: "100vh",
                padding: "100px 0",
                position: "relative",
            }}
        >
            {/* Back button */}
            <Box
                sx={{
                    position: "absolute",
                    top: "30px",
                    right: "30px",
                }}
            >
                <Link
                    to="/dashboard/profile"
                    className="btn btn-blue"
                >
                    بازگشت
                </Link>
            </Box>

            <Typography
                sx={{
                    textAlign: "center",
                    fontSize: "40px",
                    fontWeight: "bold",
                    color: COLORS.BLUE,
                }}
            >
                اشتراک پرتفویار
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: 4,
                }}
            >
                {isPlansLoading ? (
                    Array.from({ length: 4 }).map((_, index) => (
                        <Skeleton key={index} width="300px" height="400px" variant="rectangular" sx={{ borderRadius: 8 }} />
                    ))
                ) : (
                    plansData?.all_feature?.plans.map((item) => (
                        <SubscriptionCard
                            key={item.id}
                            info={item}
                            getInfoHandler={getInfoHandler}
                            plan_name={plansData.all_feature.name}
                        />
                    ))
                )}
            </Box>
        </Box>
    );
};

export default Subscription;